<template>
  <div>
    <vx-card>
      <ListProposalRefuseReasons
        :subjectPermission="subjectPermission"
      ></ListProposalRefuseReasons>
    </vx-card>
  </div>
</template>

<script>
import ListProposalRefuseReasons from './../../lists/ListProposalRefuseReasons';

export default {
  data() {
    return {
      subjectPermission: 'Recusa de Proposta',
    };
  },
  components: {
    ListProposalRefuseReasons,
  },
};
</script>
